<div class="h-full">
      <!-- Conditional rendering for each tab component -->
      <app-overview *ngIf="isActiveTab('overview')"></app-overview>
      <ng-container *ngIf="isActiveTab('profile') && profileComponent"
            [ngComponentOutlet]="profileComponent"></ng-container>
      <app-my-properties *ngIf="isActiveTab('my-properties')"></app-my-properties>
      <app-requests-offers *ngIf="isActiveTab('requests-offers')"></app-requests-offers>
      <app-analytics *ngIf="isActiveTab('analytics')"></app-analytics>
      <app-marketing *ngIf="isActiveTab('marketing')"></app-marketing>
      <app-financial *ngIf="isActiveTab('financial')"></app-financial>
      <app-manage-tickets *ngIf="isActiveTab('tickets')"></app-manage-tickets>
</div>
